import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import BadgeStatus from '../../components/BadgeStatus';
import { Button } from '@/components/ui/button';
import { ArrowRightIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { columnsDedicateInstance } from './type';

export const columns: ColumnDef<columnsDedicateInstance>[] = [
  {
    accessorKey: 'instanceName',
    header: 'Instance Name',
  },
  {
    accessorKey: 'modelName',
    header: 'Model Name',
  },
  {
    accessorKey: 'createAt',
    header: 'Created Date',
    cell: ({ row }) => {
      return (
        <span>{dayjs(row.getValue('createAt')).format('DD MMM, HH:mm')}</span>
      );
    },
    size: 110,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => {
      return <BadgeStatus status={row.getValue('status')} />;
    },
    size: 100,
  },
  {
    accessorKey: 'id',
    header: '',
    cell: ({ row }) => {
      return (
        // <Link to={row.getValue('id')}>
          <Button variant="ghost" size="icon">
            <ArrowRightIcon />
          </Button>
        // </Link>
      );
    },
    size: 40,
  },
];
